import { EpimsBaseEntityDto } from "./epim-base.dto";
export class IncidentLocationDto extends EpimsBaseEntityDto {
  LocationName: string;
  SubscriptionUserId: string;  
  Version: number;
}